import jwt_decode from 'jwt-decode';
var serverTimeoutPre = 120 * 1000;
const TIMEOUT_PERIOD = 60000;

export default class ActivityDetection {
  constructor(dataModel) {
    this.active = false;
    this.serverToken = null;
    this.sessionTimeout = parseInt(process.env.REACT_APP_SESSION_TIMEOUT_KEY ? process.env.REACT_APP_SESSION_TIMEOUT_KEY : 60 * 15, 10) * 1000;
    this.handleServerTimeout = this.handleServerTimeout.bind(this);
    this.handleClientTimeout = this.handleClientTimeout.bind(this);
    this.setActivityDetection = this.setActivityDetection.bind(this);
    this.resetActivityDetection = this.resetActivityDetection.bind(this);
    this.handleActivity = this.handleActivity.bind(this);
    this.isSessionTokenExpired = this.isSessionTokenExpired.bind(this);
    this.dataModel = dataModel;
  }

  activate(serverToken, expirationCallBack, serverExpirationCallBack) {
    if (this.active && serverToken == this.serverToken) {
      return;
    }
    this.active = true;
    this.serverToken = serverToken;
    this.expirationCallBack = expirationCallBack;
    this.serverExpirationCallBack = serverExpirationCallBack;
    if (!this.dataModel.mobileBridge.isMobile) {
      this.setActivityDetection();
      this.handleActivity();
    }
    this.dataModel.openActionCable();

    if (this.serverToken) {
      this.serverExpiration = this.serverToken;
    }
  }

  deactivate() {
    this.dataModel.closeActionCable();
    this.active = false;
    if (this.clientTimeout) {
      clearTimeout(this.clientTimeout);
      this.clientTimeout = null;
    }
    if (this.serverTimeout) {
      clearTimeout(this.serverTimeout);
      this.serverTimeout = null;
    }
    this.resetActivityDetection();
  }

  handleActivity(e) {
    if (this.clientTimeout) {
      clearTimeout(this.clientTimeout);
      this.clientTimeout = null;
    }

    if (this.active) {
      this.clientStartTime = new Date();
      this.clientTimeout = setTimeout(this.handleClientTimeout, TIMEOUT_PERIOD);
    }
  }

  setActivityDetection() {
    document.body.addEventListener('mousemove', this.handleActivity);
    document.body.addEventListener('mousedown', this.handleActivity);
    document.body.addEventListener('keydown', this.handleActivity);
    document.body.addEventListener('mousewheel', this.handleActivity);
    document.body.addEventListener('scroll', this.handleActivity);
  }

  resetActivityDetection() {
    document.body.removeEventListener('mousemove', this.handleActivity);
    document.body.removeEventListener('mousedown', this.handleActivity);
    document.body.removeEventListener('keydown', this.handleActivity);
    document.body.removeEventListener('mousewheel', this.handleActivity);
    document.body.removeEventListener('scroll', this.handleActivity);
  }
  
  isSessionTokenExpired(token) {
    if (token) {
      const decoded = jwt_decode(token);
      if (decoded && decoded.exp) {
        const actualValue = parseInt(decoded.exp, 10) * 1000 - new Date().getTime();
        return actualValue < 1000;
      }
    }
    return true;
  }

  set serverExpiration(value) {
    if (value) {
      const decoded = jwt_decode(value);
      if (decoded && decoded.exp) {
        const actualValue = parseInt(decoded.exp, 10) * 1000 - new Date().getTime();
        if (this.serverTimeout) {
          clearTimeout(this.serverTimeout);
          this.serverTimeout = null;
        }

        if (this.active) {
          const timeoutValue = actualValue - serverTimeoutPre;
          if (timeoutValue < 0) {
            if (this.serverExpirationCallBack) {
              this.serverExpirationCallBack();
            }
          }
          else {
            this.serverTimeoutValue = timeoutValue;
            this.serverStarttime = new Date();
            this.serverTimeout = setTimeout(this.handleServerTimeout, TIMEOUT_PERIOD);
          }
        }
      }
      else {
        this.handleClientTimeout();
      }
    }
  }

  handleServerTimeout() {
    const timeDiff = new Date() - this.serverStarttime;
    if (timeDiff > this.serverTimeoutValue) {
      if (this.active && this.serverExpirationCallBack) {
        this.serverExpirationCallBack();
      }
    }
    else {
      this.serverTimeout = setTimeout(this.handleServerTimeout, TIMEOUT_PERIOD);
    }
  }

  handleClientTimeout() {
    const timeDiff = new Date() - this.clientStartTime;
    if (timeDiff > this.sessionTimeout) {
      if (this.active && this.expirationCallBack) {
        this.expirationCallBack();
      }
    }
    else {
      this.clientTimeout = setTimeout(this.handleClientTimeout, TIMEOUT_PERIOD);
    }
  }

  partialLogin(user_id, password) {
    
  }
}



// WEBPACK FOOTER //
// ./src/helpers/activityDetection.js